module.exports = __webpack_public_path__ + "img/maybank-lead-senior-2.08ca551a.jpg";